import React, { useEffect, useState } from "react";
import "./CreateCampaign.css";
import Multiselect from "multiselect-react-dropdown";
import { useDispatch, useSelector } from "react-redux";
import { createCampaignData } from "../../features/createCampaign/createCampaignSlice";

import { availibilityCheckData } from "../../features/availibilityCheck/availibilityCheckSlice";
import { Check, Clear } from "@mui/icons-material";

const CreateCampaign = () => {
  const availibilityCheck = useSelector(
    (state) => state.availibilityCheck.data
  );
  const availibilityCheckpending = useSelector(
    (state) => state.availibilityCheck.pending
  );
  const availibilityCheckerror = useSelector(
    (state) => state.availibilityCheck.error
  );

  const dispatch = useDispatch();
  const createCampaign = useSelector((state) => state.createCampaign.data);
  const createCampaignpending = useSelector(
    (state) => state.createCampaign.pending
  );
  const createCampaignerror = useSelector(
    (state) => state.createCampaign.error
  );

  const [bannerAdsStartDate, setbannerAdsStartDate] = useState("");
  const [bannerAdsEndDate, setbannerAdsEndDate] = useState("");
  const [footerAdsEndDate, setfooterAdsEndDate] = useState("");
  const [footerAdsStartDate, setfooterAdsStartDate] = useState("");
  const [interstitialAdsStartDate, setinterstitialAdsStartDate] = useState("");
  const [interstitialAdsEndDate, setinterstitialAdsEndDate] = useState("");
  const [bannerDatesResponse, setbannerDatesResponse] = useState("");
  const [interstitialDatesResponse, setinterstitialDatesResponse] =
    useState("");
  const [footerDatesResponse, setfooterDatesResponse] = useState("");

  //  console.log()
  const [campaignData, setCampaignData] = useState({
    title: "",
    companyName: "",
    status: true,
    selectedAdType: [],
    ads: [
      {
        bannerAds: {
          ad_category: "",
          target_url: "",
          startDate: "",
          endDate: "",
        },
      },

      {
        footerAds: {
          ad_category: "",
          target_url: "",
          startDate: "",
          endDate: "",
        },
      },

      {
        interstitialAds: {
          ad_category: "",
          target_url: "",
          startDate: "",
          endDate: "",
        },
      },
    ],
  });

  const adTypesOptions = [
    { id: 0, value: "bannerAds", label: "BannerAds" },
    { id: 1, value: "footerAds", label: "FooterAds" },
    { id: 2, value: "interstitialAds", label: "InterstitialAds" },

    // Add more ad types as needed
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    // console.log(value);
    setCampaignData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log("ashghaksnckuyad");
    const formData = new FormData();
    formData.append("title", campaignData.title);
    formData.append("companyName", campaignData.companyName);
    formData.append("status", campaignData.status);
    formData.append("ads", JSON.stringify(campaignData.ads));
    formData.append(
      "selectedAdTypes",
      JSON.stringify(campaignData.selectedAdType)
    );
    formData.append(
      "bannerAds",
      campaignData?.ads[0]?.bannerAds?.bannerAds_image
    );
    formData.append(
      "footerAds",
      campaignData?.ads[0]?.footerAds?.footerAds_image
    );
    formData.append(
      "interstitialAds",
      campaignData?.ads[0]?.interstitialAds?.interstitialAds_image
    );

    dispatch(createCampaignData(formData))
      .then((result) => {
        if (result?.payload?.response?.status === 404) {
          alert(result?.payload?.response?.data?.msg);
        } else if (result?.payload?.status === true) {
          window.location.href = "https://api.cricway.live/admin/all-campaign";
          alert(result?.payload?.msg);
        }

        console.log("Form submitted successfully!", result);
        //  window.location.reload()
        // Handle the result as needed
      })
      .catch((error) => {
        console.error("Form submission failed:", error.message);
        // Handle the error as needed
      });
  };

  const handleSelect = (selectedList) => {
    console.log(selectedList);
    setCampaignData((prevData) => ({
      ...prevData,
      selectedAdType: selectedList,
    }));
    for (let i = 0; i < selectedList.length; i++) {
      console.log(selectedList[i].value);
      switch (selectedList[i].value) {
        case "bannerAds":
          setCampaignData((prevFormData) => ({
            ...prevFormData,
            ads: [
              {
                ...prevFormData.ads[0],
                bannerAds: {
                  ...prevFormData.ads[0].bannerAds,
                  ad_category: selectedList[i].label,
                },
              },
            ],
          }));
          // setCampaignData((campaignData) =>({...campaignData, bannerAds:{...campaignData.bannerAds, ad_category: selectedList[i].label }}))
          break;
        case "footerAds":
          setCampaignData((prevFormData) => ({
            ...prevFormData,
            ads: [
              {
                ...prevFormData.ads[0],
                footerAds: {
                  ...prevFormData.ads[0].footerAds,
                  ad_category: selectedList[i].label,
                },
              },
            ],
          }));
          // setCampaignData((campaignData) =>({...campaignData, footerAds:{...campaignData.footerAds, ad_category: selectedList[i].label }}))
          break;
        case "interstitialAds":
          setCampaignData((prevFormData) => ({
            ...prevFormData,
            ads: [
              {
                ...prevFormData.ads[0],
                interstitialAds: {
                  ...prevFormData.ads[0].interstitialAds,
                  ad_category: selectedList[i].label,
                },
              },
            ],
          }));

          break;
        default:
          return null;
      }
    }
  };

  const handleFileChange = (e) => {
    // console.log(e.target)
    const image = e.target.files[0];
    const id = e.target.id;

    switch (id) {
      case "bannerAds":
        setCampaignData((prevFormData) => ({
          ...prevFormData,
          ads: [
            {
              ...prevFormData.ads[0],
              bannerAds: {
                ...prevFormData.ads[0].bannerAds,
                bannerAds_image: image,
              },
            },
          ],
        }));
        break;

      case "footerAds":
        setCampaignData((prevFormData) => ({
          ...prevFormData,
          ads: [
            {
              ...prevFormData.ads[0],
              footerAds: {
                ...prevFormData.ads[0].footerAds,
                footerAds_image: image,
              },
            },
          ],
        }));
        // setCampaignData({...campaignData, "footerAds_image" : image
        //  });
        break;

      case "interstitialAds":
        setCampaignData((prevFormData) => ({
          ...prevFormData,
          ads: [
            {
              ...prevFormData.ads[0],
              interstitialAds: {
                ...prevFormData.ads[0].interstitialAds,
                interstitialAds_image: image,
              },
            },
          ],
        }));
        // setCampaignData({...campaignData, "interstitialAds_image" : image
        //  });
        break;

      default:
        return null;
    }
  };

  useEffect(() => {
    if (bannerAdsStartDate !== "" && bannerAdsEndDate !== "") {
      if (bannerAdsStartDate > bannerAdsEndDate) {
        setbannerDatesResponse("dates are wrong");
      } else {
        dispatch(
          availibilityCheckData({
            id: "BannerAds",
            newAdStartDate: campaignData.ads[0].bannerAds.startDate,
            newAdEndDate: campaignData.ads[0].bannerAds.endDate,
          })
        )
          .then((result) => {
            console.log(result);
            setbannerDatesResponse(result.payload.msg);
            // Handle the result as needed
          })
          .catch((error) => {
            console.error("Form submission failed:", error.message);
            // Handle the error as needed
          });
      }
    }
  }, [bannerAdsStartDate, bannerAdsEndDate]);

  useEffect(() => {
    if (footerAdsStartDate !== "" && footerAdsEndDate !== "") {
      if (footerAdsStartDate > footerAdsEndDate) {
        setfooterDatesResponse("dates are wrong");
      } else {
        dispatch(
          availibilityCheckData({
            id: "FooterAds",
            newAdStartDate: campaignData.ads[0].footerAds.startDate,
            newAdEndDate: campaignData.ads[0].footerAds.endDate,
          })
        )
          .then((result) => {
            console.log(result);
            setfooterDatesResponse(result.payload.msg);
            // Handle the result as needed
          })
          .catch((error) => {
            console.error("Form submission failed:", error.message);
            // Handle the error as needed
          });
      }
    }
  }, [footerAdsStartDate, footerAdsEndDate]);

  useEffect(() => {
    if (interstitialAdsStartDate !== "" && interstitialAdsEndDate !== "") {
      if (interstitialAdsStartDate > interstitialAdsEndDate) {
        setinterstitialDatesResponse("dates are wrong");
      } else {
        dispatch(
          availibilityCheckData({
            id: "InterstitialAds",
            newAdStartDate: campaignData.ads[0].interstitialAds.startDate,
            newAdEndDate: campaignData.ads[0].interstitialAds.endDate,
          })
        )
          .then((result) => {
            setinterstitialDatesResponse(result.payload.msg);
          })
          .catch((error) => {
            console.error("Form submission failed:", error.message);
            // Handle the error as needed
          });
      }
    }
  }, [interstitialAdsStartDate, interstitialAdsEndDate]);

  const createAdHandleChange = async (e, index) => {
    const { name, value, id } = e.target;

    switch (id) {
      case "bannerAds":
        setCampaignData((prevFormData) => ({
          ...prevFormData,
          ads: [
            {
              ...prevFormData.ads[0],
              bannerAds: {
                ...prevFormData.ads[0].bannerAds,
                [name]: value,
              },
            },
          ],
        }));

        if (name === "startDate") {
          setbannerAdsStartDate(value);
        } else if (name === "endDate") {
          setbannerAdsEndDate(value);
        }

        break;

      case "footerAds":
        setCampaignData((prevFormData) => ({
          ...prevFormData,
          ads: [
            {
              ...prevFormData.ads[0],
              footerAds: {
                ...prevFormData.ads[0].footerAds,
                [name]: value,
              },
            },
          ],
        }));
        if (name === "startDate") {
          setfooterAdsStartDate(value);
        } else if (name === "endDate") {
          setfooterAdsEndDate(value);
        }

        break;

      case "interstitialAds":
        setCampaignData((prevFormData) => ({
          ...prevFormData,
          ads: [
            {
              ...prevFormData.ads[0],
              interstitialAds: {
                ...prevFormData.ads[0].interstitialAds,
                [name]: value,
              },
            },
          ],
        }));

        if (name === "startDate") {
          setinterstitialAdsStartDate(value);
        } else if (name === "endDate") {
          setinterstitialAdsEndDate(value);
        }
        break;

      default:
        return null;
    }
  };

  const handleClearOnClick = (e, id) => {
    // console.log(id)
    const updatedItems = campaignData.selectedAdType.filter(
      (item) => item.id !== id
    );
    handleSelect(updatedItems);
    // console.log(updatedItems)
  };

  const generateInputFields = () => {
    const inputFields = [];
    for (let i = 0; i < campaignData.selectedAdType.length; i++) {
      inputFields.push(
        <div key={i} className="input-group">
          <div className="createAd">
            <h4 className="adHeading">
              {campaignData.selectedAdType[i].label}
            </h4>
            <Clear
              className="clearForm"
              onClick={(e) =>
                handleClearOnClick(e, campaignData.selectedAdType[i].id)
              }
            />
            {/* <br/> */}
            <label className="startDate">
              Start Date:
              <input
                required
                type="date"
                name="startDate"
                id={`${campaignData.selectedAdType[i].value}`}
                value={
                  campaignData.ads[0][`${campaignData.selectedAdType[i].value}`]
                    .startDate
                }
                onChange={(e) => createAdHandleChange(e, i)}
              />
            </label>

            <label className="endDate">
              End Date:
              <input
                required
                type="date"
                name="endDate"
                id={`${campaignData.selectedAdType[i].value}`}
                value={
                  campaignData.ads[0][`${campaignData.selectedAdType[i].value}`]
                    .endDate
                }
                onChange={(e) => createAdHandleChange(e, i)}
              />
            </label>

            <label className="targetUrl">
              Target URL:
              <input
                type="text"
                name="target_url"
                id={`${campaignData.selectedAdType[i].value}`}
                required
                value={
                  campaignData.ads[0][`${campaignData.selectedAdType[i].value}`]
                    .target_url
                }
                onChange={(e) => createAdHandleChange(e, i)}
                disabled={
                  (campaignData.selectedAdType[i].value === "bannerAds" &&
                    (bannerDatesResponse === "" ||
                      bannerDatesResponse === "dates are wrong" ||
                      bannerDatesResponse === "Dates are not Available")) ||
                  (campaignData.selectedAdType[i].value === "footerAds" &&
                    (footerDatesResponse === "" ||
                      footerDatesResponse === "dates are wrong" ||
                      footerDatesResponse === "Dates are not Available")) ||
                  (campaignData.selectedAdType[i].value === "interstitialAds" &&
                    (interstitialDatesResponse === "" ||
                      interstitialDatesResponse === "dates are wrong" ||
                      interstitialDatesResponse === "Dates are not Available"))
                }
              />
            </label>

            <label className="fileUpload">
              Upload Files:
              <input
                type="file"
                name="files"
                required
                accept="image/png, image/jpeg, image/gif, image/tiff, image/psd,"
                id={`${campaignData.selectedAdType[i].value}`}
                disabled={
                  (campaignData.selectedAdType[i].value === "bannerAds" &&
                    (bannerDatesResponse === "" ||
                      bannerDatesResponse === "dates are wrong" ||
                      bannerDatesResponse === "Dates are not Available")) ||
                  (campaignData.selectedAdType[i].value === "footerAds" &&
                    (footerDatesResponse === "" ||
                      footerDatesResponse === "dates are wrong" ||
                      footerDatesResponse === "Dates are not Available")) ||
                  (campaignData.selectedAdType[i].value === "interstitialAds" &&
                    (interstitialDatesResponse === "" ||
                      interstitialDatesResponse === "dates are wrong" ||
                      interstitialDatesResponse === "Dates are not Available"))
                }
                onChange={handleFileChange}
              />
            </label>

            <div className="availibilityStatus">
              {/* {campaignData.selectedAdType[i].value === 'bannerAds' && (<div>{}<div/>)(<div>{bannerDatesResponse === '' && (<div className="emptyStatus"></div>)}{bannerDatesResponse === "Dates are not Available" && (<div className="availibilityStatusfail"><Clear className="clear"/><p>Slots are not Available</p></div>)}{bannerDatesResponse === 'Dates are Available' && (<div className="availibilityStatusSuccess"><Check className="check"/><p>Slots are Available</p></div>)}</div>)} */}
              {campaignData.selectedAdType[i].value === "bannerAds" && (
                <div>
                  {bannerDatesResponse === "dates are wrong" && (
                    <div className="emptyStatus">
                      <Clear className="clear" />
                      End Date Should be greater than Start date
                    </div>
                  )}
                  {bannerDatesResponse === "Dates are not Available" && (
                    <div className="availibilityStatusfail">
                      <Clear className="clear" />
                      <p>Slots are not Available</p>
                    </div>
                  )}
                  {bannerDatesResponse === "Dates are Available" && (
                    <div className="availibilityStatusSuccess">
                      <Check className="check" />
                      <p>Slots are Available</p>
                    </div>
                  )}
                </div>
              )}
              {campaignData.selectedAdType[i].value === "footerAds" && (
                <div>
                  {footerDatesResponse === "dates are wrong" && (
                    <div className="emptyStatus">
                      <Clear className="clear" />
                      End Date Should be greater than Start date
                    </div>
                  )}
                  {footerDatesResponse === "Dates are not Available" && (
                    <div className="availibilityStatusfail">
                      <Clear className="clear" />
                      <p>Slots are not Available</p>
                    </div>
                  )}
                  {footerDatesResponse === "Dates are Available" && (
                    <div className="availibilityStatusSuccess">
                      <Check className="check" />
                      <p>Slots are Available</p>
                    </div>
                  )}
                </div>
              )}
              {campaignData.selectedAdType[i].value === "interstitialAds" && (
                <div>
                  {interstitialDatesResponse === "dates are wrong" && (
                    <div className="emptyStatus">
                      <Clear className="clear" />
                      End Date Should be greater than Start date
                    </div>
                  )}
                  {interstitialDatesResponse === "Dates are not Available" && (
                    <div className="availibilityStatusfail">
                      <Clear className="clear" />
                      <p>Slots are not Available</p>
                    </div>
                  )}
                  {interstitialDatesResponse === "Dates are Available" && (
                    <div className="availibilityStatusSuccess">
                      <Check className="check" />
                      <p>Slots are Available</p>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
          {/* 
          <input type="text" name={`ad${i}`} /> */}
        </div>
      );
    }
    return inputFields;
  };

  return (
    //   <div>
    //   <label htmlFor="adCount">Select the number of ads:</label>
    //   <select id="adCount" onChange={handleAdCountChange} value={adCount}>
    //     <option value="0">Select</option>
    //     <option value="1">1 Ad</option>
    //     <option value="2">2 Ads</option>
    //     <option value="3">3 Ads</option>
    //     {/* Add more options as needed */}
    //   </select>

    // </div>
    <div className="createCampaign">
      <div className="createCampaignWrapper">
        <h2 className="formTitle">Create New Campaign </h2>
        <form
          className="campaignForm"
          onSubmit={handleSubmit}
          encType="multipart/form-data"
        >
          <label>
            Title:
            <input
              type="text"
              name="title"
              required
              value={campaignData.title}
              onChange={handleChange}
            />
          </label>
          <br />

          <label>
            Company Name:
            <input
              type="text"
              name="companyName"
              required
              value={campaignData.companyName}
              onChange={handleChange}
            />
          </label>
          <br />

          <label className="adSelectionInput">
            Select Ad Types:
            <Multiselect
              className="multiselect"
              options={adTypesOptions}
              selectedValues={campaignData.selectedAdType}
              onSelect={handleSelect}
              onRemove={handleSelect}
              displayValue="label"
              required
            />
          </label>
          <br />

          {/* <button className='createAdButton' onClick={()=>{handleCreateAd()}}>+ Create Ad</button> */}

          {/* <label>
      Upload Files:
      <input type="file" name="files" multiple onChange={handleFileChange} />
    </label>
    <br /> */}

          {/* <CreateAdForm /> */}
          <div id="inputFieldsContainer">{generateInputFields()}</div>

          <button type="submit" className="createCampaignButton">
            Create Campaign
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateCampaign;
